import type { ReactNode } from 'react';

const STAP_LABELS = [
  'Account',
  'Meterkast',
  'Woninggegevens',
  'Apparaten',
  'Laadwensen',
  'Samenvatting',
] as const;

interface Props {
  huidigeStap: number; // 1-indexed, 1–7 (7 = success screen, no progress bar)
  children: ReactNode;
}

export default function WizardLayout({ huidigeStap, children }: Props) {
  return (
    <div className="lc-wizard">
      {/* Progress bar — hidden on step 7 (WooCommerce takes over) */}
      {huidigeStap < 7 && (
        <nav className="lc-wizard__voortgang" aria-label="Wizard voortgang">
          <div
            className="lc-wizard__balk"
            role="progressbar"
            aria-valuenow={huidigeStap}
            aria-valuemin={1}
            aria-valuemax={6}
          >
            <div
              className="lc-wizard__balk-fill"
              style={{ width: `${((huidigeStap - 1) / 5) * 100}%` }}
            />
          </div>
          <ol className="lc-wizard__stappen">
            {STAP_LABELS.slice(0, 6).map((label, i) => {
              const nr = i + 1;
              const isKlaar = nr < huidigeStap;
              const isActief = nr === huidigeStap;
              return (
                <li
                  key={label}
                  className={[
                    'lc-wizard__stap',
                    isKlaar ? 'lc-wizard__stap--klaar' : '',
                    isActief ? 'lc-wizard__stap--actief' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  aria-current={isActief ? 'step' : undefined}
                >
                  <span className="lc-wizard__stap-nr" aria-hidden="true">
                    {isKlaar ? '✓' : nr}
                  </span>
                  <span className="lc-wizard__stap-label">{label}</span>
                </li>
              );
            })}
          </ol>
        </nav>
      )}

      <div className="lc-wizard__inhoud">{children}</div>
    </div>
  );
}
